const HEADER_TOP_ROW_HEIGHT = 32;
const HEADER_BOTTOM_ROW_HEIGHT = 70;
// This is exported so other components can calculate their height or positioning
// based on this.
export const SITE_HEADER_HEIGHT = HEADER_TOP_ROW_HEIGHT + HEADER_BOTTOM_ROW_HEIGHT;
export const MAIN_CONTENT_HEADER_HEIGHT = 90;
